const Pattern = {
  isEmpty: /(^\s*)|(\s*$)/g,
  isMobile: /^1\d{10}$/,
  isEmail: /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/,
  isImage: /\.(jpeg|jpe|jpg|gif|png|webp)$/i,
};

const validator = {
  /**
   * 执行测试
   * @param pattern
   * @param value
   */
  exec(pattern, value) {
    return pattern.test(value);
  },
  /**
   * 是否为空字符
   * @param value
   * @returns {boolean}
   */
  isEmpty(value) {
    const str = value.replace(Pattern.isEmpty, '');
    return str.length === 0;
  },
  /**
   * 是否为空对象
   * @param obj
   * @returns {boolean}
   */
  isEmptyObj(obj) {
    return Object.keys(obj).length === 0;
  },
  /**
   * 是否非空字符
   * @param value
   * @returns {boolean}
   */
  isNotEmpty(value) {
    return !this.isEmpty(value);
  },
  /**
   * 字符长度是否在某个区间内
   * @param str
   * @param lengthArray
   * @returns {boolean}
   */
  isLenRange(str, lengthArray) {
    return str.length >= lengthArray[0] && str.length <= lengthArray[1];
  },
  /**
   * 数字是否在某个区间内
   * @param num
   * @param numArray
   * @returns {boolean}
   */
  isNumRange(num, numArray) {
    return num >= numArray[0] && num <= numArray[1];
  },
  /**
   * 是否是手机号
   * @param value
   * @returns {*}
   */
  isMobile(value) {
    if (this.isEmpty(value)) return false;
    return this.exec(Pattern.isMobile, value);
  },
  /**
   * 是否是电子邮箱地址
   * @param value
   * @returns {*}
   */
  isEmail(value) {
    if (this.isEmpty(value)) return false;
    return this.exec(Pattern.isEmail, value);
  },
  /**
   * 对象是否存在某个属性
   * @param obj
   * @param key
   * @returns {boolean}
   */
  hasProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  },
  /**
   * 是否图片
   * @param name
   * @returns {*}
   */
  isImage(name) {
    return this.exec(Pattern.isImage, name);
  },
  /**
   * 是否是对象
   * @param obj
   * @returns {boolean}
   */
  isObject(obj) {
    return typeof obj === 'object';
  },
};

export default validator;
